export type TicketsNumerationType = 1 | 2 | 3;
interface ITicketsNumerationTypeEnum {
    ServiceNumeration: TicketsNumerationType;
    GeneralNumeration: TicketsNumerationType;
    GroupNumeration: TicketsNumerationType;
    getName(): string;
    format(value: number): string;
    displayTypesArray(): any[];
}

const dataSource = () => [
    { key: 1, text: 'Atskira numeracija kiekvienos paslaugos bilietėliams'},
    { key: 2, text: 'Bendra numeracija visiems bilietėliams'}
];

export const ticketsNumerationType: ITicketsNumerationTypeEnum = {
    ServiceNumeration: 1,
    GeneralNumeration: 2,
    GroupNumeration: 3,
    getName() {
        return 'TicketsNumerationType';
    },
    format(value: number): string {
        const item = dataSource().find(x => x.key === value);
        return item ? item.text : '';
    },
    displayTypesArray() {
        const types: any[] = [];
        dataSource().map(x => {
            types.push(x);
        });
        return types;
    }
};
